export const FISHYMAP_TRADE_NPC_CATALOG_CHANGED_EVENT =
  "fishymap:trade-npc-catalog-changed";

function cloneJson(value) {
  return JSON.parse(JSON.stringify(value));
}

function normalizedStatus(value) {
  const status = String(value ?? "").trim().toLowerCase();
  return status === "loading" || status === "loaded" || status === "error"
    ? status
    : "idle";
}

export function dispatchShellTradeNpcCatalogChangedEvent(
  shell,
  { catalog = null, status = "idle" } = {},
  customEventConstructor = globalThis.CustomEvent,
) {
  if (
    !shell ||
    typeof shell.dispatchEvent !== "function" ||
    typeof customEventConstructor !== "function"
  ) {
    return false;
  }
  const clonedCatalog = catalog && typeof catalog === "object"
    ? cloneJson(catalog)
    : null;
  const nextStatus = normalizedStatus(status);
  shell.fishyMapTradeNpcCatalog = clonedCatalog;
  shell.fishyMapTradeNpcCatalogStatus = nextStatus;
  shell.dispatchEvent(
    new customEventConstructor(FISHYMAP_TRADE_NPC_CATALOG_CHANGED_EVENT, {
      bubbles: true,
      detail: {
        catalog: clonedCatalog ? cloneJson(clonedCatalog) : null,
        status: nextStatus,
      },
    }),
  );
  return true;
}
